import { createContext, useContext, useState, useEffect } from 'react';
import { register as registerApi, loginRequest, logoutRequest, addRoleRequest } from '../api/authApi';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    const saved = localStorage.getItem('authUser');
    if (accessToken && saved) setUser(JSON.parse(saved));
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await loginRequest({ email, password });
    localStorage.setItem('accessToken', data.data.accessToken);
    localStorage.setItem('refreshToken', data.data.refreshToken);
    localStorage.setItem('authUser', JSON.stringify(data.data.user));
    setUser(data.data.user);
    return data.data;
  };

  const register = async ({ name, email, password, phone }) => {
    await registerApi({ name, email, password, phone });
    return login(email, password);
  };

  const logout = async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      try {
        await logoutRequest(refreshToken);
      } catch {
        // best-effort — still clear local session even if the API call fails
      }
    }
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('authUser');
    setUser(null);
  };

  const addRole = async (role) => {
    const { data } = await addRoleRequest(role);
    const updated = { ...user, roles: data.data.roles };
    localStorage.setItem('authUser', JSON.stringify(updated));
    setUser(updated);
    return data.data;
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, addRole, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);